import * as React from 'react';
import Card from '@mui/material/Card';
import CardHeader from '@mui/material/CardHeader';

import CardContent from '@mui/material/CardContent';

import Typography from '@mui/material/Typography';
import { ReactComponent as Globe } from 'assets/images/ic_globe.svg';
import { ReactComponent as ContactMultiple } from 'assets/images/ic_contact_multiple.svg';
import { Stack, SvgIcon } from '@mui/material';
import { AppPrimaryButton } from 'shared/components/AppComponents';

interface ContactPartnerInterface {
  title: string;
  contactLink: string;
  website: string;
  description: string;
}

const ContactPartnerHub: React.FC<ContactPartnerInterface> = (props) => {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const { title, contactLink, website, description } = props;
  // UI Elements
  return (
    <Card variant="outlined">
      <CardHeader
        sx={{
          flexDirection: { xs: 'column', sm: 'row' },
          alignItems: { xs: 'flex-start', sm: 'center' },
        }}
        action={
          <Stack
            direction="row"
            spacing={3}
            sx={{ marginTop: { xs: '12px', sm: '1px' } }}
          >
            <AppPrimaryButton
              title="Contact"
              startIcon={
                <SvgIcon
                  component={ContactMultiple}
                  inheritViewBox
                  className="view-icon"
                  fontSize="inherit"
                  htmlColor="#76A81F"
                />
              }
              onClick={() => {
                window.open(contactLink, 'contact');
              }}
            />
            <AppPrimaryButton
              title="Website"
              startIcon={
                <SvgIcon
                  component={Globe}
                  inheritViewBox
                  className="view-icon"
                  fontSize="inherit"
                  htmlColor="#76A81F"
                />
              }
              onClick={() => {
                window.open(website, 'website');
              }}
            />
          </Stack>
        }
        title={title}
      />

      <CardContent>
        <Typography variant="body2" sx={{ color: 'text.secondary' }}>
          {description}
        </Typography>
      </CardContent>
    </Card>
  );
};

export default ContactPartnerHub;
